import type JobTableCSVViewModel from 'ab-viewModels/jobTableCSV.viewModel';

import { capitalize } from '@acceligentllc/shared/utils/text';
import { formatDate } from '@acceligentllc/shared/utils/time';

import { stateAbbreviation } from '@acceligentllc/shared/enums/state';
import { TimeFormat } from '@acceligentllc/shared/enums/timeFormat';
import { WorkRequestStatus } from '@acceligentllc/shared/enums/workRequestStatus';

const CSV_HEADER_KEYS = [
	'Finished',
	'Status',
	'Job number',
	'Customer Company',
	'Job Title',
	'City',
	'State',
	'Calculated Start Date',
	'Guaranteed Completion Date',
	'Expected Completion Date',
	'Est Total Price',
	'Office',
	'Division',
	'Project Manager',
	'Priority',
	'Updated',
];

export const toCSVData = (viewModels: JobTableCSVViewModel[]): string[][] => {
	const header: string[] = [...CSV_HEADER_KEYS];

	const rows: string[][] = viewModels.map((_entry: JobTableCSVViewModel) => {
		const _row: string[] = [
			_entry?.status === WorkRequestStatus.FINISHED ? 'Yes' : 'No',
			_entry?.jobStatus?.name ?? 'None',
			_entry?.jobCode,
			_entry?.customerCompanyName ?? '-',
			_entry?.title ?? '',
			_entry?.travelLocation?.city ?? '-',
			(_entry?.travelLocation?.state && stateAbbreviation[_entry.travelLocation.state]) ?? _entry?.travelLocation?.state ?? '-',
			_entry?.calculatedStartDate ? formatDate(_entry.calculatedStartDate) : '-',
			_entry?.guaranteedCompletionDate ? formatDate(_entry.guaranteedCompletionDate) : '-',
			_entry?.targetCompletionDate ? formatDate(_entry.targetCompletionDate) : '-',
			_entry?.estimateTotal?.toString() ?? '-',
			_entry?.office ?? '-',
			_entry?.division ?? '-',
			_entry?.projectManager ?? '-',
			capitalize(_entry?.priority) ?? '-',
			`${formatDate(_entry?.updatedAt, TimeFormat.FULL_DATE)} by ${_entry?.updatedBy?.fullName}`,
		];
		return _row;
	});

	return [header, ...rows];
};
